module.exports = __webpack_public_path__ + "static/media/SimpleTriangle.e816f7bb.jpg";